// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vnfcWwJtekT6rzjOwCcV {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1440px;
  margin: auto;
}

.XGtUcO3AqvFL0FBEI0FF  {
  width: 60%;
}

.jDCEGIc75Y0FWROLj39G {
  width: 35%;
}

.iFDjmI4pHoAaehIWUukd {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.iFDjmI4pHoAaehIWUukd button {
  margin-bottom: 0;
}

.oO4BoPfwCObVYhLoZlMw {
  padding: 4px;
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
}

.nCGd9VqcBkjeGsIYNYR_ {
  margin-bottom: 0;
  margin-top: 0;
}

.vttZ0vI20V_J6PK1pRUl {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.vttZ0vI20V_J6PK1pRUl > div {
  width: 49%;
}

.vttZ0vI20V_J6PK1pRUl > div p:last-child {
  margin: 0;
}

.G4hqRSvJCF3YS37TPiMq {
  margin-bottom: 16px;
}

.rsgDel7DWSmLYbGyELWU, .WKopIYQINSbNZXlYbQGr {
  padding: 16px;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]};
  border-radius: 5px;
}

.WKopIYQINSbNZXlYbQGr {
  margin-top: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.WKopIYQINSbNZXlYbQGr p {
  margin: 0 0 8px 0;
  font-weight: 500;
  font-size: 16px;
  text-align: left;
}

.WKopIYQINSbNZXlYbQGr button {
  margin-bottom: 0;
  width: max-content;
  height: 32px;
  min-width: 0;
  font-size: 16px;
  text-align: left;
}

.J20gTxBdQvgAfGB8NRX9 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.J20gTxBdQvgAfGB8NRX9 p {
  margin: 8px 0;
}

.J20gTxBdQvgAfGB8NRX9 .HJ1NeaPAUI0KNCTa45LR, .J20gTxBdQvgAfGB8NRX9 .UrDeREsWNV10yoRG3dI6, .J20gTxBdQvgAfGB8NRX9 .HJ1NeaPAUI0KNCTa45LR {
  font-size: 16px;
}

.z15ycpZTj1pxniJ7fX9N {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.POlNgpiMIAC5uuZGmv0A {
  height: 38px;
  align-items: center;
  background: white;
  padding: 0 24px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
  font-weight: 400;
  font-size: 16px;
}

.c2oxJiL1N4gRZIC0CDc3 {
  width: 50%;
  border-radius: 0 5px 5px 0;
  border-left: 0 solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]};
}

.IH_myhbB78mnRnHF566E {
  width: 50%;
  border-radius: 5px 0 0 5px;
  border-right: 0 solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]};
}

.RsqFJRHXpewmDa8ajnyR {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  font-weight: 500;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
}

.sUoYnwTnWi84yiznasmN {
  width: 50%;
}

.sUoYnwTnWi84yiznasmN > div {
  max-height: 100px;
}

.jlFmGa0HvXe_bNNaE0Ma {
  margin: 0 auto;
  padding: 48px;
  min-width: 370px;
}

.jlFmGa0HvXe_bNNaE0Ma .TbHkRxK5OAUz1fOUFxUZ {
  font-family: Raleway, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
}

.xS4EEYJ9brdwnNrn07AX {
  display: flex;
  align-items: center;
}
.UrDeREsWNV10yoRG3dI6 {
  text-align: right;
}

.QabK3Lm8cLxQj1BdESaw {
  margin-left: auto;
}

.GnOUNqKSULCxvKD5LSDM {
  margin-right: 8px;
}

.G3oYWkRMYx_dQkexiBto div + div {
  margin-left: 16px;
}

.phj4ygvhBEy31s956riL {
  border-bottom: 1px solid #E9EFFD;
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.HJ1NeaPAUI0KNCTa45LR {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
}

.kJRiRSxSCIaHv_vbntvg {
  font-weight: 500;
}

.tWDzeDSWoACW8BJtSpIB {
  font-weight: 500;
  font-size: 24px;
  text-align: right;
}

.kcpS68dtzzqJtDlS6uuX {
  width: 100%;
  margin-top: 24px;
}

._v4kuXhWPY8u0Xprc691 {
  font-weight: 500;
  text-decoration: none;
}

.VxcyhWK510HWmXNq2_eC {
  display: none;
}

.vQ6qOfODDD4JGUaNh5GD {
  display: block;
}

.xKJtPmMaagrMB5O2t8CA {
  width: 100%;
  min-height: 100vh;
  background-color: rgba(255, 255,255, .75);

  position: absolute;
  top: 0;
  right: 0;
  z-index: 100;

  display: flex;
  justify-content: center;
  align-items: center;
}

.y2dBi4qZqEzXwujtEKTr {
  background-color: white;
  box-shadow: 0 0 10px rgb(0 0 0 / 12%), -1px 9px 9px rgb(0 0 0 / 2%);;
  padding: 24px;
  border-radius: 5px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 90%;
  max-width: 520px;
}

.TbHkRxK5OAUz1fOUFxUZ {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  margin-top: 24px;
  text-align: center;
}

.x9CbIgDTNFEO8aBkmKqw {
  margin-top: 8px;
  margin-bottom: 24px;
  text-align: center;
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
}

.EkpJOoNSBix1nA3Q4Wm6 {
  background: linear-gradient(90deg, rgba(248,250,255,1) 0%, rgba(248,250,255,1) 35%, rgba(255,255,255,1) 100%);
}

@media screen and (max-width: 1440px) {
  .vnfcWwJtekT6rzjOwCcV {
    width: 90%;
  }
}


@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .vQ6qOfODDD4JGUaNh5GD {
    display: none;
  }

  .VxcyhWK510HWmXNq2_eC {
    display: block;
  }

  .vnfcWwJtekT6rzjOwCcV {
    display: flex;
    flex-direction: column;
    background-color: #F8FAFF;
    position: relative;
    z-index: -100;
  }
  .jDCEGIc75Y0FWROLj39G {
    width: 100%;
    margin-bottom: 24px;
    margin-top: 24px;
  }
  .XGtUcO3AqvFL0FBEI0FF {
    width: 100%;
  }

  .EkpJOoNSBix1nA3Q4Wm6 {
    position: relative;
    z-index: 0;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
  .POlNgpiMIAC5uuZGmv0A {
    padding: unset;
  }
  .sUoYnwTnWi84yiznasmN {
    width: 100%;
  }
  .EkpJOoNSBix1nA3Q4Wm6 h1 {
    text-align: center;
  }

  .vnfcWwJtekT6rzjOwCcV {
    width: 100%;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}) {
  .iFDjmI4pHoAaehIWUukd {
    flex-direction: column;
  }
}


@media screen and (min-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}) and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .J20gTxBdQvgAfGB8NRX9 {
    grid-template-columns: 55% 45%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Investments/Investments.module.css"],"names":[],"mappings":"AAMA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mDAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8DAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,8DAA4B;EAC5B,mDAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,iEAA+B;AACjC;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,kEAAgC;AAClC;;AAEA;EACE,8DAAiC;EACjC,mDAAmB;EACnB,gBAAgB;EAChB,8DAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mDAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yCAAyC;;EAEzC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;;EAEZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mEAAmE;EACnE,aAAa;EACb,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mDAAwB;AAC1B;;AAEA;EACE,6GAA6G;AAC/G;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs, tablet from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle from colors;\n\n.formContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  max-width: 1440px;\n  margin: auto;\n}\n\n.form  {\n  width: 60%;\n}\n\n.amountContainer {\n  width: 35%;\n}\n\n.formHeader {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.formHeader button {\n  margin-bottom: 0;\n}\n\n.required {\n  padding: 4px;\n  color: color-purple;\n}\n\n.requiredTag {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.formRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.formRow > div {\n  width: 49%;\n}\n\n.formRow > div p:last-child {\n  margin: 0;\n}\n\n.formBody {\n  margin-bottom: 16px;\n}\n\n.simulation, .upsell {\n  padding: 16px;\n  background-color: color-purple-bg;\n  border-radius: 5px;\n}\n\n.upsell {\n  margin-top: 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.upsell p {\n  margin: 0 0 8px 0;\n  font-weight: 500;\n  font-size: 16px;\n  text-align: left;\n}\n\n.upsell button {\n  margin-bottom: 0;\n  width: max-content;\n  height: 32px;\n  min-width: 0;\n  font-size: 16px;\n  text-align: left;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid p {\n  margin: 8px 0;\n}\n\n.grid .subtle, .grid .right, .grid .subtle {\n  font-size: 16px;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.button {\n  height: 38px;\n  align-items: center;\n  background: white;\n  padding: 0 24px;\n  border: 1px solid color-gray;\n  color: color-text-subtle;\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.buttonRight {\n  width: 50%;\n  border-radius: 0 5px 5px 0;\n  border-left: 0 solid color-gray;\n}\n\n.buttonLeft {\n  width: 50%;\n  border-radius: 5px 0 0 5px;\n  border-right: 0 solid color-gray;\n}\n\n.active {\n  background-color: color-purple-bg;\n  color: color-purple;\n  font-weight: 500;\n  border: 1px solid color-purple;\n}\n\n.choiceButton {\n  width: 50%;\n}\n\n.choiceButton > div {\n  max-height: 100px;\n}\n\n.details {\n  margin: 0 auto;\n  padding: 48px;\n  min-width: 370px;\n}\n\n.details .title {\n  font-family: Raleway, sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n}\n.right {\n  text-align: right;\n}\n\n.rightContent {\n  margin-left: auto;\n}\n\n.radio {\n  margin-right: 8px;\n}\n\n.radioContainer div + div {\n  margin-left: 16px;\n}\n\n.separator {\n  border-bottom: 1px solid #E9EFFD;\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n}\n\n.subtle {\n  color: color-text-subtle;\n}\n\n.total {\n  font-weight: 500;\n}\n\n.totalValue {\n  font-weight: 500;\n  font-size: 24px;\n  text-align: right;\n}\n\n.submit {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.link {\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.displayMobile {\n  display: none;\n}\n\n.displayDesktop {\n  display: block;\n}\n\n.background {\n  width: 100%;\n  min-height: 100vh;\n  background-color: rgba(255, 255,255, .75);\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 100;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal {\n  background-color: white;\n  box-shadow: 0 0 10px rgb(0 0 0 / 12%), -1px 9px 9px rgb(0 0 0 / 2%);;\n  padding: 24px;\n  border-radius: 5px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  width: 90%;\n  max-width: 520px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  margin-top: 24px;\n  text-align: center;\n}\n\n.description {\n  margin-top: 8px;\n  margin-bottom: 24px;\n  text-align: center;\n  color: color-text-subtle;\n}\n\n.content {\n  background: linear-gradient(90deg, rgba(248,250,255,1) 0%, rgba(248,250,255,1) 35%, rgba(255,255,255,1) 100%);\n}\n\n@media screen and (max-width: 1440px) {\n  .formContainer {\n    width: 90%;\n  }\n}\n\n\n@media screen and (max-width: tablet-l) {\n  .displayDesktop {\n    display: none;\n  }\n\n  .displayMobile {\n    display: block;\n  }\n\n  .formContainer {\n    display: flex;\n    flex-direction: column;\n    background-color: #F8FAFF;\n    position: relative;\n    z-index: -100;\n  }\n  .amountContainer {\n    width: 100%;\n    margin-bottom: 24px;\n    margin-top: 24px;\n  }\n  .form {\n    width: 100%;\n  }\n\n  .content {\n    position: relative;\n    z-index: 0;\n  }\n}\n\n@media screen and (max-width: tablet) {\n  .button {\n    padding: unset;\n  }\n  .choiceButton {\n    width: 100%;\n  }\n  .content h1 {\n    text-align: center;\n  }\n\n  .formContainer {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: mobile-xs) {\n  .formHeader {\n    flex-direction: column;\n  }\n}\n\n\n@media screen and (min-width: mobile-xs) and (max-width: tablet-l) {\n  .grid {\n    grid-template-columns: 55% 45%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"formContainer": `vnfcWwJtekT6rzjOwCcV`,
	"form": `XGtUcO3AqvFL0FBEI0FF`,
	"amountContainer": `jDCEGIc75Y0FWROLj39G`,
	"formHeader": `iFDjmI4pHoAaehIWUukd`,
	"required": `oO4BoPfwCObVYhLoZlMw`,
	"requiredTag": `nCGd9VqcBkjeGsIYNYR_`,
	"formRow": `vttZ0vI20V_J6PK1pRUl`,
	"formBody": `G4hqRSvJCF3YS37TPiMq`,
	"simulation": `rsgDel7DWSmLYbGyELWU`,
	"upsell": `WKopIYQINSbNZXlYbQGr`,
	"grid": `J20gTxBdQvgAfGB8NRX9`,
	"subtle": `HJ1NeaPAUI0KNCTa45LR`,
	"right": `UrDeREsWNV10yoRG3dI6`,
	"buttonContainer": `z15ycpZTj1pxniJ7fX9N`,
	"button": `POlNgpiMIAC5uuZGmv0A`,
	"buttonRight": `c2oxJiL1N4gRZIC0CDc3`,
	"buttonLeft": `IH_myhbB78mnRnHF566E`,
	"active": `RsqFJRHXpewmDa8ajnyR`,
	"choiceButton": `sUoYnwTnWi84yiznasmN`,
	"details": `jlFmGa0HvXe_bNNaE0Ma`,
	"title": `TbHkRxK5OAUz1fOUFxUZ`,
	"row": `xS4EEYJ9brdwnNrn07AX`,
	"rightContent": `QabK3Lm8cLxQj1BdESaw`,
	"radio": `GnOUNqKSULCxvKD5LSDM`,
	"radioContainer": `G3oYWkRMYx_dQkexiBto`,
	"separator": `phj4ygvhBEy31s956riL`,
	"total": `kJRiRSxSCIaHv_vbntvg`,
	"totalValue": `tWDzeDSWoACW8BJtSpIB`,
	"submit": `kcpS68dtzzqJtDlS6uuX`,
	"link": `_v4kuXhWPY8u0Xprc691`,
	"displayMobile": `VxcyhWK510HWmXNq2_eC`,
	"displayDesktop": `vQ6qOfODDD4JGUaNh5GD`,
	"background": `xKJtPmMaagrMB5O2t8CA`,
	"modal": `y2dBi4qZqEzXwujtEKTr`,
	"description": `x9CbIgDTNFEO8aBkmKqw`,
	"content": `EkpJOoNSBix1nA3Q4Wm6`
};
export default ___CSS_LOADER_EXPORT___;
